// src/api/services/applicationHousingService.ts
import api from "../axios";

export interface ApplicationHousingEntryDto {
  id: number;
  createdAt: string;
  address: string;
  moveInDate: string;
  moveOutDate?: string;
  currentResidence: boolean;
  manager: string;
  phone: string;
  email: string;
}

export type ApplicationHousingEntryFormInput = Omit<ApplicationHousingEntryDto, "id" | "createdAt">;

export function getHousingEntries(uuid: string) {
  return api.get<ApplicationHousingEntryDto[]>(`/applications/${uuid}/housing`);
}

export function createHousingEntry(
  uuid: string,
  data: Omit<ApplicationHousingEntryDto, "id" | "createdAt">
) {
  return api.post<ApplicationHousingEntryDto>(`/applications/${uuid}/housing`, data);
}

export function updateHousingEntry(
  uuid: string,
  housingId: number,
  data: Omit<ApplicationHousingEntryDto, "id" | "createdAt">
) {
  return api.put<ApplicationHousingEntryDto>(
    `/applications/${uuid}/housing/${housingId}`,
    data
  );
}

export function deleteHousingEntry(uuid: string, housingId: number) {
  return api.delete<void>(`/applications/${uuid}/housing/${housingId}`);
}